import React from 'react';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import BlogFour from '../components/blog/BlogFour';
import BrandOne from '../components/brand/BrandOne';
import FooterOne from '../common/footer/FooterOne';

const BlogPage = () => {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                heading="Latest News"
                currentPage="Blog Grid" 
            />
            <BlogFour />
            <BrandOne />
            <FooterOne />
        </>
    )
}

export default BlogPage;